import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FacebookSDKProvider from './FacebookSDKProvider';
import ShareButton from './ShareButton';

import { getFacebookUrlInfo } from 'cityads-v3/actions/social';

@connect(
  (state, props) => ({
    shareInfo: state.social.fbInfoByUrl[props.url],
  })
)
export default class FacebookShareButton extends PureComponent {
  static propTypes = {
    url      : PropTypes.string,
    shareInfo: PropTypes.oneOfType([ PropTypes.object, PropTypes.oneOf([ false ]) ]),
  }

  componentDidMount() {
    const { dispatch, shareInfo, url } = this.props;

    if (!shareInfo && shareInfo !== null && shareInfo !== false) {
      dispatch(getFacebookUrlInfo(url));
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, shareInfo, url } = this.props;
    const { url: prevUrl } = prevProps;

    if (prevUrl !== url && !shareInfo && shareInfo !== null && shareInfo !== false) {
      dispatch(getFacebookUrlInfo(url));
    }
  }

  render() {
    const { url, shareInfo, ...rest } = this.props;

    return (
      <FacebookSDKProvider>
        {(FB) => (
          <ShareButton
            icon    = {require('./FacebookShareButton.png')}
            count   = {(shareInfo && shareInfo.share) ? shareInfo.share.share_count : null}
            url     = {url}
            onClick = {(evt) => {
              FB && FB.ui({
                method: 'share',
                href  : url,
              }, null);

              evt.stopPropagation();
            }}
            {...rest}
          />
        )}
      </FacebookSDKProvider>
    );
  }
}
